<template>
  <div>
    <van-row>
      <van-col
        span="2"
        class="father"
      >
        <van-icon
          class="song"
          size="0.6rem"
          color="#c3c3c3"
          name="arrow-left"
          @click="back"
        />
      </van-col>
      <van-search
        placeholder="请输入搜索关键词"
        shape="round"
        v-model="text"
        @search="search"
      />
      <van-col span="20"></van-col>
    </van-row>
  </div>
</template>
<script>
import Vue from 'vue';
import { Search, Col, Row, Icon } from 'vant';

Vue.use(Search).use(Row).use(Col).use(Icon);
export default {
  data () {
    return {
      text: ''
    }
  },
  methods: {
    back () {
      if(this.$store.state.spid==21){
      this.$router.go(-2)

      }else{
      this.$router.go(-1)

      }
    },
    search () {
      if (this.text == "") {
        return
      }
      this.$emit('search', this.text)
    }
  }
}
</script>
<style lang="less" scoped>
.song {
  padding-top: 0.45rem;
  padding-left: 0.2rem;
}
.van-search__content {
  background-color: #ededed;
}
</style>